export default {
    allFields: {
        orderId: 'Order number',
        message: 'Description',
        date: 'Alert date',
        priority: 'Priority',
    },

    priority: {
        high: 'High',
        medium: 'Medium',
        low: 'Low',
    },

    empty: 'There are no actual alerts',
};